<template>
  <div>
    <h1 class="page-header">
      User
    </h1>
    <div class="row">
      <div class="col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <ts-button outline color="info" waiting>Add new</ts-button>
          </ts-card-wrapper>
          <ts-table
            :columns="columns"
            :records="users"
            showCheckbox
            :loading="true"
          >
            <template v-slot="{ record }">
              <td>{{ record.id }}</td>
              <td>{{ record.username }}</td>
              <td>{{ record.email }}</td>
              <td class="d-flex">
                <ts-button icon color="primary" class="mr-3">
                  <i class="fas fa-edit"></i>
                </ts-button>
                <ts-button icon color="danger">
                  <i class="fas fa-trash"></i>
                </ts-button>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'User',
  data() {
    return {
      search: '',
      pagination: {
        currentPage: 2,
        lastPage: 2,
        perPage: 5,
        total: 10
      },
      columns: [
        'id',
        'username',
        'email',
        { name: 'action', style: 'width: 1px' }
      ],
      users: [
        {
          id: 1,
          username: 'user1',
          email: 'user1@mail.com'
        },
        {
          id: 2,
          username: 'user2',
          email: 'user2@mail.com'
        },
        {
          id: 3,
          username: 'user1',
          email: 'user1@mail.com'
        },
        {
          id: 4,
          username: 'user2',
          email: 'user2@mail.com'
        }
      ]
    }
  },
  methods: {
    fetchData() {}
  }
}
</script>
